/**
 * Whether the overview header shows search, sort, and List/Map switch.
 * Hidden when the organisation has no projects so the empty state stays focused.
 */
export const shouldShowProjectListChrome = (projectCount: number): boolean =>
  projectCount > 0;
